const Basket                    = require('app/components/checkout/steps/Basket')
const ProductItem               = require('app/components/checkout/mixins/ProductItem')
const PriceLine                 = require('app/components/checkout/mixins/PriceLine')
const Widget                    = require('app/components/checkout/mixins/Widget')
const PropTypes                 = require('prop-types')
const assign                    = require('object-assign')
const { groupProductItems }     = require('app/util/cart')
const Confirm                   = require('app/components/modals/Confirm')
const env                       = require('app/services/env')
const { numberFormat }          = require('app/util/formaters')
const TextCardSelector          = require('app/components/products/configuration/TextCardSelector')
const RibbonSelector            = require('app/components/products/configuration/RibbonSelector')
const queryObject               = require('app/util/queryObject')
const router                    = require('app/services/router')
const debounce                  = require('app/util/debounce')
const truncateText              = require('app/util/truncateText')
const MobileOption              = require('app/components/products/configuration-mobile/MobileOption')
const { reject }                = require('lodash')
const { trackInitiateCheckout } = require('../../../services/tracking')
const axios                     = require("axios")
const i18n = require("i18next");

const Trans = require('app/components/trans/Trans')


/////////////////////////////////
// Widgets
/////////////////////////////////

class DeliveryWidget extends Widget {

	static get propTypes() {
		return {
			value: PropTypes.string.isRequired
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			onChange: PropTypes.func
		};
	}

	get title() {
		return translate( "Leveringsform" );
	}

	get className() {
		return super.className + " delivery-widget";
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.selectElement.value) {
			this.selectElement.value = nextProps.value;
		}
	}

	_onSelectChange = (e) => {
		if (typeof this.props.onChange === "function") {
			this.props.onChange(e.target.value);
		}
	};

	renderOptions() {
		const options = env.get("checkout.delivery.options", {});

		return Object.keys(options).map(value => {
			return (
				<option key={value} value={value}>{options[value]}</option>
			);
		});
	}

	renderOptionsMobile() {
		const options = env.get("checkout.delivery.options", {});

		return Object.keys(options).map((value, key) => 
			<MobileOption key={value} value={value} name={'delivery-options'} text={options[value]} defaultChecked={key === 0} onClick={() => this.handleMobileOptionClick(value)} />
		)
	}

	handleMobileOptionClick (val) {
		this.props.onChange(val)
	}

	renderBody() {
		return (
			<>
				<select ref={el => this.selectElement = el} onChange={this._onSelectChange}
								defaultValue={this.state.value}>{this.renderOptions()}</select>
			</>
		);
	}

}

class DiscountWidget extends Widget {

	static get propTypes() {
		return {
			value: PropTypes.string,
			error: PropTypes.string,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			value: "",
			error: null
		};
	}

	get title() {
		return translate("GAVEKORT / RABATKODE");
	}

	get className() {
		return super.className + " discount-widget";
	}

	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			error: props.error
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.error !== this.state.error) {
			this.setState({error: nextProps.error});
		}
	}

	onSubmit = (e) => {
		e.preventDefault();

		if (typeof this.props.onChange === "function") {
			this.props.onChange(this.inputElement.value);
		}
	};

	renderBody() {
		return (
			<form onSubmit={this.onSubmit}>
				<input type="text" ref={el => this.inputElement = el} defaultValue={this.state.value || ""}/>
				<button type="submit"><Trans>Indløs</Trans></button>
			</form>
		);
	}

	renderFooter() {
		if (this.state.error) {
			return (
				<div className="widget-error">{this.state.error}</div>
			);
		}
	}

}


/////////////////////////////////
// Item
/////////////////////////////////

class Item extends ProductItem {

	static get propTypes() {
		return assign({}, super.propTypes, {
			remove: PropTypes.func,
			duplicate: PropTypes.func,
			updateTextCard: PropTypes.func,
			updateRibbon: PropTypes.func
		});
	}

	constructor(props) {
		super(props);
		this.state = {
			editor: null
		};
	}

	_onEditorChangeListener = (editor) => {
		return (e) => {
			e.preventDefault();
			this.setEditor(editor);
		};
	};

	setEditor(editor = null) {
		this.setState({editor});
	}

	remove = () => {
		if (typeof this.props.remove === "function") {
			return this.props.remove(this.props.id);
		}
	};

	duplicate = () => {
		if (typeof this.props.duplicate === "function") {
			this.props.duplicate(this.props.id);
		}
	};

	updateTextCard = (e) => {
		e.preventDefault();
		if (typeof this.props.updateTextCard === "function") {
			this.props.updateTextCard(this.props.id, this.textCardEditor.value).then(() => {
				this.setState({editor: null});
			});
		}
	};

	onTextCardChange = debounce(1000, (val) => {
		if (typeof this.props.updateTextCard === "function") {
			this.props.updateTextCard(this.props.id, this.textCardEditor.value);
		}
	});

	updateRibbon = (e) => {
		e.preventDefault();
		if (typeof this.props.updateRibbon === "function") {
			this.props.updateRibbon(this.props.id, this.ribbonEditor.value).then(() => {
				this.setState({editor: null});
			});
		}
	};

	get textCardName() {
		if (typeof this.props.textCard !== "number") {
			return;
		}

		const cardData = env.get("checkout.textCards", []).filter(card => card.id === this.props.textCard).pop();
		return cardData ? cardData.name : null;
	}

	get ribbonName() {
		if (!this.props.ribbon || !this.props.ribbon.details) {
			return;
		}

		const {details: {ribbon_id}} = this.props.ribbon;

		const ribbonData = env.get("checkout.ribbons", []).filter(ribbon => ribbon.id === ribbon_id).pop();
		return ribbonData ? ribbonData.name : null;
	}

	renderCardInfo() {
		if (this.props.textCard == undefined) {
			return;
		}

		return (
			<div className="text-card-info">
				<div>
                    <Trans>Korttype</Trans>: <span>{this.textCardName || translate("Ingen")}</span>
					{!this.props.cardText ? <span className="missing-text"> | <span> <Trans>Ingen tekst</Trans></span></span> : <span className="card-text-preview"> | {truncateText(this.props.cardText, 18)}</span>}
				</div>
				<a href="#" onClick={this._onEditorChangeListener("card")}><Trans>Ret</Trans></a>
			</div>
		);
	}

	renderRibbonInfo() {
		if (this.props.productType !== "funeral") {
			return;
		}

		return (
			<div className="ribbon-info">
				<div><Trans>Bånd</Trans>: <span>{this.ribbonName || translate("Ingen")}</span></div>
              <a href="#" onClick={this._onEditorChangeListener("ribbon")}><Trans>Ret</Trans></a>
			</div>
		);
	}

	renderBody() {
		return (
			<div className="item-body">
				<div className="thumbnail">
					<img src={this.props.thumbnail} alt={this.props.name} className="main" />
					<div onClick={this.duplicate} className="duplicate-phone"><Trans>Tilføj igen</Trans></div>
					<div onClick={this.duplicate} className="duplicate">
						<div className="image-overlay"></div>
						<img src={router.url("img/duplicate.svg")} />
					</div>
				</div>
				<div className="details">
					<div className="details-inner">
						<div className="info">
							<div className="title">
								<div className="the-title">{this.props.name}</div>
							</div>
							{this.renderDescription()}
						</div>
						<div onClick={this.remove} className="remove">
							<div className="line-1"></div>
							<div className="line-2"></div>
						</div>
						<div className="price">{numberFormat(this.total)}</div>
					</div>
					{this.renderCardInfo()}
					{this.renderRibbonInfo()}
				</div>
			</div>
		);
	}

	renderWarnings() {
		if (this.textCardName !== translate('Kort fravalgt')) return;

		const text = translate('Du har fravalgt kort til din ordre, derfor vil det ikke fremgå hvem ordren er fra.');

		return (<p className="item-warning">{text}</p>);
	}

	renderTextCardEditor() {
		if (this.props.textCard == undefined) {
			return;
		}

		let classList = ["editor", "text-card-editor"];

		if (this.state.editor === "card") {
			classList.push("active");
		}

		return (
			<div className={classList.join(" ")}>
				<TextCardSelector ref={el => this.textCardEditor = el} option={this.props.textCard}
								text={this.props.cardText} onChange={this.onTextCardChange} />
				<a href="#" onClick={this.updateTextCard}><Trans>Gem</Trans></a>
			</div>
		);
	}

	renderRibbonEditor() {
		if (this.props.productType !== "funeral") {
			return;
		}

		let classList = ["editor", "ribbon-editor"];

		if (this.state.editor === "ribbon") {
			classList.push("active");
		}

		const texts = queryObject(this.props, 'ribbon.texts');
		const ribbon_id = queryObject(this.props, 'ribbon.details.ribbon_id');

		const messages = !Array.isArray(texts) ? [] :
			texts.map(text => text.text);

		return (
			<div className={classList.join(" ")}>
				<RibbonSelector ref={el => this.ribbonEditor = el} option={ribbon_id} texts={messages}/>
				<a href="#" onClick={this.updateRibbon}><Trans>Gem</Trans></a>
			</div>
		);
	}

	renderExtras() {
		let classList = ["editors"];

		if (this.state.editor != null) {
			classList.push("show");
		}

		return (
			<React.Fragment>
				<div className="mobile-buttons">
					<div onClick={this.remove} className="mobile-btn mobile-btn--outlineGray">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
							<g transform="translate(-680.001 -1691)">
								<path d="M135,1682a6,6,0,1,0,6,6A6,6,0,0,0,135,1682Zm0,10.875a4.875,4.875,0,1,1,4.875-4.875A4.875,4.875,0,0,1,135,1692.874Z" transform="translate(551.001 9.001)" fill="#444"/>
								<path d="M137.875,1686,136,1687.874,134.125,1686,133,1687.124l1.875,1.875L133,1690.874l1.125,1.125,1.875-1.875,1.875,1.875,1.125-1.125L137.125,1689l1.875-1.875Z" transform="translate(550.001 8.001)" fill="#444"/>
							</g>
						</svg>
						<span><Trans>Slet</Trans></span>
					</div>
					<div onClick={this.duplicate} className="mobile-btn mobile-btn--outlineGray">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
							<path d="M711,1650a6,6,0,1,0,6,6A6,6,0,0,0,711,1650Zm0,10.5a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,711,1660.5Zm3-3.75h-2.25V1659h-1.5v-2.25H708v-1.5h2.25V1653h1.5v2.25H714Z" transform="translate(-705 -1649.999)" fill="#444"/>
						</svg>
						<span><Trans>Kopier</Trans></span>
					</div>
					<div onClick={this._onEditorChangeListener("card")} className="mobile-btn mobile-btn--outlineGray">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
							<g transform="translate(-1160.001 -187)">
								<path d="M618,184.874V189h-7.5v-7.5h4.125l1.5-1.5h-6A1.128,1.128,0,0,0,609,181.124v8.25a1.128,1.128,0,0,0,1.125,1.125h8.25a1.128,1.128,0,0,0,1.125-1.125v-6Z" transform="translate(551.001 8.501)" fill="#444"/>
								<path d="M620.125,178,613,185.124V187h1.875L622,179.874A1.771,1.771,0,0,0,620.125,178Z" transform="translate(550.001 9.001)" fill="#444"/>
							</g>
						</svg>
						<span><Trans>Ret korttekst</Trans></span>
					</div>
				</div>
				<div>
					{this.renderWarnings()}
					<div className={classList.join(" ")}>
						{this.renderTextCardEditor()}
						{this.renderRibbonEditor()}
					</div>
				</div>
			</React.Fragment>
		);
	}

}

/////////////////////////////////
// Basket
/////////////////////////////////

class ProductBasket extends Basket {

	constructor(props) {
		super(props);


		if (this.cart === undefined) {
			console.log("cart undefined");
			/*this.pipelines.clear.request.dispatch().then(() => {
				this.setState({submitting: false});
			});*/
		}

		this.state = assign({}, this.state, {
			discountError: null,
			allowEmptyCards: false,
			allowEmptyRibbons: false,
		});
	}

	get baseClassName() {
		return super.baseClassName + " product-basket";
	}

	get description() {
		return (
          <span><Trans>Antal produkter</Trans>: <b>{this.cart.items.length}</b></span>
		);
	}

	get itemComponent() {
		return Item;
	}

	get items() {
		return groupProductItems(this.cart.items);
	}

	get cards() {
		return env.get("checkout.textCards", []);
	}

	getCardById (id) {
		return this.cards.find(c => c.id === id)
	}

	getCardName (card) {
		let card_name = 'kort'

		switch (card.name) {
			case translate('Pænt kort til lejligheden'):
				card_name = translate('pænt kort')
				break

			case translate('Printet korttekst'):
				card_name = translate('kort')
				break

			default:
				card_name = card.name.toLowerCase()
		}

		return card_name
	}

	getFirstEmptyCard () {
		return Promise.resolve(
			this.state.cart.items.find(item => {
				const card = this.getCardById(item.textCard)

				return card && card.has_text && !item.cardText
			})
		)
	}

	getRibbonEndName (end = 0) {
		// const lineNumber = end % 2 === 0 ? 1 : 2
		const endNumber = Math.floor(end/2+1)

        return translate('Båndende :endNumber', {endNumber: endNumber});
	}

	ribbonEndIsEmpty (text) {
		return text.ribbon_end % 2 === 0 && text.text === null
	}

	getFirstEmptyRibbon () {
	  return Promise.resolve(
			this.state.cart.items.find(item => {
			  const ribbon = item.ribbon

				if (ribbon && ribbon.texts !== undefined && ribbon.texts.length > 0) {
					return -1 < ribbon.texts.findIndex(this.ribbonEndIsEmpty)
				}
			})
		)
	}

	next() {
    const payload = {};

    return Promise.resolve()
			.then(() => {
				if (!this.state.allowEmptyCards) {
					return this.getFirstEmptyCard()
				}
			})
			.then(emptyCard => {
				if (emptyCard !== undefined) {
					payload.emptyCardItem = emptyCard

					const cardName = this.getCardName(
						this.getCardById(emptyCard.textCard)
					)

					return this.confirm.await(
                      translate( `Er det korrekt, at der ikke skal skrives noget tekst i kortet? Vi leverer et :cardName uden tekst, hvis du trykker godkend`, {cardName: cardName}),
                      translate('Ingen korttekst!')
					);
				}
			})
			.catch(() => {
				const item_card_ref = this['item_' + payload.emptyCardItem.id];

				if (item_card_ref) {
					item_card_ref.setEditor('card');
				}

				return Promise.reject()
			})
			.then(() => {
				// IF emptyCards are not allowed, AND currently has Empty Card
				// Remember we allowed empty cards
				if (!this.state.allowEmptyCards && payload.emptyCardItem !== undefined) {
					this.setState({allowEmptyCards: true});
				}
			})
			.then(() => {
				if (!this.state.allowEmptyRibbons) {
					return this.getFirstEmptyRibbon()
				}
			})
			.then(emptyRibbon => {
			  if (emptyRibbon !== undefined) {
					payload.emptyRibbonItem = emptyRibbon

					const ribbonName = this.getRibbonEndName(
						emptyRibbon.ribbon.texts.find(this.ribbonEndIsEmpty).ribbon_end
					)

					return this.confirm.await(
                        translate('Er det korrekt, at der ikke skal skrives noget tekst på :ribbonName? Vi leverer båndende som du har skrevet det, hvis du trykker godkend.', {ribbonName: ribbonName}),
                        translate('Er der fejl i båndtekst?')
					);
				}
			})
			.catch(() => {
				const item_ribbon_ref = this['item_' + payload.emptyRibbonItem.id];

				if (item_ribbon_ref) {
					item_ribbon_ref.setEditor('ribbon');
				}

				return Promise.reject()
			})
			.then(() => {
				// IF emptyRibbons are not allowed, AND currently has Empty Ribbon
				// Remember we allowed empty ribbons
				if (!this.state.allowEmptyRibbons && payload.emptyRibbonItem !== undefined) {
					this.setState({allowEmptyRibbons: true});
				}
			})
			.then(() => {
				if (this.cart.items.length > 0) {
					trackInitiateCheckout(this.cart.items)
				}
			})
			.then(() => {
				return axios.post(router.route("api.tracking.start-checkout"), {cart_id: this.cart.guid});
			})
			.then(() => {
				return super.next();
			})
	}

	return() {
		this.pipelines.clear.request.dispatch().then(() => {
			this.setState({submitting: false});
		});

		return false;
	}

	buildItemProps(item) {
		return assign({}, item, {
			remove: this.onRemoveItem,
			duplicate: this.onDuplicateListener(item),
			updateTextCard: this.onUpdateTextCard,
			updateRibbon: this.onUpdateRibbon
		});
	}

	onRemoveItem = (id) => {
		return this.pipelines.remove.request.dispatch({item_id: id});
	};

	onUpdateTextCard = (id, value) => {
		return this.pipelines.textCard.update.dispatch({
			item_id: id,
			card_type: value.type,
			card_message: value.text
		});
	};

	onUpdateRibbon = (id, value) => {
		let payload = {item_id: id};

		if (value) {
			payload.ribbon_id = value.id;
			payload.ribbon_messages = value.messages;
		}

		return this.pipelines.ribbon.update.dispatch(payload);
	};

	onDuplicateListener = (item) => {
		return () => {
			const payload = {
				product_id: item.product,
				price: item.price,
				card_type: item.textCard,
				card_message: item.cardText,
			};

			if (item.color) {
				payload.color = item.color.id;
			}

			if (item.ribbon && item.ribbon.details) {
				payload.ribbon_id = item.ribbon.details.ribbon_id;
                payload.ribbon_messages = item.ribbon.texts.map(txt => txt.text);
			}

			this.pipelines.add.request.dispatch(payload);
		};
	};

	onDeliveryChange = (value) => {
		return this.pipelines.delivery.update.dispatch({type: value});
	};

	onDiscountChange = (value) => {
		return this.pipelines.discount.update.dispatch({code: value}).then(() => {
			this.setState({discountError: null});
		}).catch(error => {
			this.setState({
				discountError: error.response.data.message
			});
		});
	};

	renderWidgets() {
		return (
			<div className="widgets delivery-widgets">
				<DeliveryWidget value={this.cart.delivery} onChange={this.onDeliveryChange}/>
				<Confirm className="card_confirm_modal"
								 containerRefId="modalContainerCart"
								 confirm={translate("Godkend")} cancel={translate("Nej, udfyld")}
								 ref={el => this.confirm = el}/>
			</div>
		);
	}

	renderDeliveryPrice() {
		return (<PriceLine title={translate('Levering - Udbringning')} value={this.cart.price.delivery}/>)
	}

	renderDiscountPrice() {
		if (!this.cart.discount) {
			return;
		}

		return (<PriceLine title={translate('Gavekort / Rabatkode')} value={this.cart.price.discount}/>)
	}

	renderExtraPrices() {
		return (
			<div className="extra-prices">
				{this.renderDeliveryPrice()}
				{this.renderDiscountPrice()}
			</div>
		);
	}

	renderTotalPrice() {
		return (
			<PriceLine title="Total" value={this.cart.price.total} description={translate('Med levering & inkl. moms.')}/>
		);
	}

	renderAdditionalActions() {
		return (
			<div id="trash-can" onClick={this.prev.bind(this)}>
				<img src={router.url("img/trashcan.svg")} />
			</div>
		);
	}


}

module.exports = ProductBasket;
